import { canonical } from "@utils";

export default {
	name: "NYTGames",
	data() {
		return {
			wordleCards: [
				{
					to: "/wordle/",
					bgColor: "#77B850",
					title: "Wordle",
					subtitle: "Solver",
				},
				{
					to: "/wordle/hints/",
					bgColor: "#F3C237",
					title: "Wordle",
					subtitle: "Today's Hints & Answer",
				},
				{
					to: "/wordle/yesterday-hints/",
					bgColor: "black",
					title: "Wordle",
					subtitle: "Yesterday’s Hints & Answer",
					textColor: "white",
				},
				{
					to: "/wordle/answers/",
					bgColor: "black",
					title: "Wordle",
					subtitle: "Archive of Past Answers",
					textColor: "white",
				},
			],
			connectionsCards: [
				{
					to: "/nyt-connections/",
					bgColor: "#BE70C4",
					title: "Connections",
					subtitle: "Today's Hints & Answers",
				},
				{
					to: "/nyt-connections/yesterday-hints/",
					bgColor: "#B4A8FE",
					title: "Connections",
					subtitle: "Yesterday’s Hints & Answer",
				},
				{
					to: "/nyt-connections/todays-answers/",
					bgColor: "#B4A8FE",
					title: "Connections",
					subtitle: "Archive of Past Answers",
				},
			],
			dailyHelperCards: [
				{
					to: "/nyt-strands/",
					bgColor: "#AAE5F2",
					title: "NYT Strands",
					subtitle: "Today's Hints & Answers",
				},
				{
					to: "/nyt-spelling-bee/",
					bgColor: "#F7DA21",
					title: "NYT Spelling Bee",
					subtitle: "Today's Answers",
				},
				{
					to: "/crosswords/new-york-times-crossword/",
					bgColor: "#6493E6",
					title: "NYT Crossword",
					subtitle: "Clues & Answers",
				},
			],
			crossplayHelperCards: [
				{
					to: "/nyt-crossplay/",
					bgColor: "#3A6EBA",
					title: "NYT Crossplay",
					subtitle: "Cheat",
					textColor: "white",
				},
				{
					to: "/nyt-crossplay-dictionary/",
					bgColor: "#C6DAEB",
					title: "NYT Crossplay",
					subtitle: "Dictionary",
					textColor: "black",
				},
			],
		};
	},
	head() {
		return {
			title: "NYT Daily Answers & Hints - WordFinder®",
			meta: [
				{
					name: "description",
					hid: "description",
					content:
						"Level up your NYT Daily Games with our ultimate cheats and helpers. Including the latest answers for Wordle, Connections, Strands, and Spelling Bee.",
				},
			],
			link: [canonical(this.$route)],
		};
	},
};
